import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
// const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const NoHomologados = Loadable(lazy(() => import('views/pages/homologaciones/NoHomologados')));
const Homologados = Loadable(lazy(() => import('views/pages/homologaciones/Homologados')));
const MaestroDistribuidoras = Loadable(lazy(() => import('views/pages/maestro/MaestroDistribuidoras')));
const MaestroProductos = Loadable(lazy(() => import('views/pages/maestro/MaestroProductos')));

const MaestroLocales = Loadable(lazy(() => import('views/pages/maestro/MaestroLocalesHomologados')));
const MaestroLocalesNoHomologados = Loadable(lazy(() => import('views/pages/maestro/MaestroLocalesNoHomologados')));

const MaestroProductosMT = Loadable(lazy(() => import('views/pages/maestro/MaestroProductosMT')));
const HomologadosMT = Loadable(lazy(() => import('views/pages/homologaciones/HomologadosMT')));
const NoHomologadosMT = Loadable(lazy(() => import('views/pages/homologaciones/NoHomologadosMT')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        // Tradicional
        {
            path: 'homologaciones/homologados',
            element: <Homologados />
        },
        {
            path: 'homologaciones/no-homologados',
            element: <NoHomologados />
        },
        {
            path: 'maestros/productos',
            element: <MaestroProductos />
        },
        // Moderno
        {
            path: 'homologaciones/homologadosmt',
            element: <HomologadosMT />
        },
        {
            path: 'homologaciones/no-homologadosmt',
            element: <NoHomologadosMT />
        },
        {
            path: 'maestros/productosmt',
            element: <MaestroProductosMT />
        },
        {
            path: 'maestros/localesmt',
            element: <MaestroLocales />
        },
        {
            path: 'maestros/localesmtnohomologados',
            element: <MaestroLocalesNoHomologados />
        },

    ]
};

export default MainRoutes;
